import {
  AccountClient,
  apiResolver,
  GET_CLIENTS,
  RMMClient
} from '@nile/graphql';
import { GET_CLIENT_SITE_LIST_FOR_DROPDOWN } from '@nile/banyan/src/Graphql/Mutations/site';
import { cloneDeep } from 'lodash';
import { platformCategoryOptions } from '@nile/rmm/src/modules/asset-management/components/constants/asset-rule-builder';
import { GET_WORKSTATION_LIST } from '@nile/rmm/src/modules/asset-management/Graphql/asset';
// this will be changed in asset details -> patches (AssetPatch)
let apiResolverModule = 'Patch';

const getAPIResolverModule = () => {
  return apiResolverModule;
};

const setAPIResolverModule = (m) => {
  apiResolverModule = m;
};

const getDefaultValue = (f, condition) => {
  const operands = cloneDeep(condition.operands);
  const ruleIdx = operands.findIndex((el) => {
    if (f.dataType === 'entity') {
      return el.attribute === `${f.name}.name`;
    }
    return el.attribute === f.name;
  });
  if (ruleIdx > -1) {
    const rule = operands[ruleIdx];
    switch (f.dataType) {
      case 'date':
      case 'datetime':
        return rule.value;
      default:
        break;
    }
    switch (f.filterType) {
      case 'text':
      case 'numeric':
      case 'decimal':
      case 'paragraph':
      case 'read_only':
        return rule.value;
      default:
        return rule.value.map((el) => {
          return {
            name: el,
            value: el,
            label: el
          };
        });
    }
  }
  return '';
};
const checkDynamicQuery = (f) => {
  switch (f.name) {
    case 'account':
    case 'workStation.name':
    case 'workStation.client.name':
    case 'workStation.site.name':
    case 'workStation.status':
    case 'workStation.platformCategory':
    case 'site':
    case 'approvalStatus':
    case 'category':
    case 'severity':
    case 'patchDetail.approvalStatus':
    case 'patchDetail.category':
    case 'patchDetail.severity':
    case 'patchDetail.stabilitySeverity':
    case 'installationStatus':
    case 'patchDetail.stabilitySeverity':
      return true;
    default:
      return false;
  }
};

const getDynamicQuery = (f) => {
  let client = RMMClient;
  let query = apiResolver[getAPIResolverModule()][f.name]?.api;
  switch (f.name) {
    case 'account':
    case 'workStation.client.name':
      client = AccountClient;
      query = GET_CLIENTS;
      return client.query({
        query: query,
        variables: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      });
    case 'site':
    case 'workStation.site.name':
      client = AccountClient;
      query = GET_CLIENT_SITE_LIST_FOR_DROPDOWN;
      return client.query({
        query: query,
        variables: {
          input: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      });
    case 'patchDetail.stabilitySeverity':
      return {
        data:[
          { label: 'Stable', value: 'STABLE' },
          { label: 'Neutral', value: 'NEUTRAL' },
          { label: 'Caution', value: 'CAUTION' }
        ]
      }
    case 'installationStatus':
      return {
        data: [
          { label: 'New or Missing', value: 'NewOrMissing' },
          {
            label: 'Reboot Required',
            name: 'RebootRequired',
            value: 'RebootRequired'
          },
          { label: 'Installed', value: 'Installed' },
          { label: 'Failed', value: 'Failed' }
        ]
      };
    case 'platformCategory':
    case 'workStation.platformCategory':
      return {
        data: platformCategoryOptions
      };
    case 'workStation.status':
      return {
        data: [
          {
            label: 'ONLINE',
            value: 'ONLINE'
          },
          {
            label: 'OFFLINE',
            value: 'OFFLINE'
          }
        ]
      };
    default:
      query = apiResolver[getAPIResolverModule()][f.name]?.api;
      client = apiResolver[getAPIResolverModule()][f.name]?.client;
      return client.query({
        query: query
      });
  }
};

const getPatchCategorySeverityOptions = (data, keyToAccess) => {
  const obj = {
    categories: data.categories,
    severities: data.severities
  };
  return obj[keyToAccess].map((el) => {
    return {
      name: el.name,
      value: el.name,
      label: el.name
    };
  });
};
const getAsyncOptions = (property) => {
  return { client: RMMClient, query: GET_WORKSTATION_LIST };
};
const generateOptions = (f, data) => {
  let allValues = [];
  switch (f.name) {
    case 'account':
    case 'workStation.client.name':
      allValues = data.getClientList.clients.map((el) => {
        return {
          ...el,
          name: el.accountId,
          value: el.name,
          label: el.name
        };
      });
      break;
    case 'site':
    case 'workStation.site.name':
      allValues = data.getClientSiteList.sites.map((el) => {
        return {
          ...el,
          name: el.siteId,
          value: el.name,
          label: el.name
        };
      });
      break;
    case 'approvalStatus':
    case 'patchDetail.approvalStatus':
      allValues = data?.getPatchApprovalStatusMeta?.map((el) => {
        return {
          ...el,
          name: el,
          value: el,
          label: el
        };
      });
      break;
    case 'workStation.platformCategory':
    case 'installationStatus':
    case 'workStation.status':
    case 'patchDetail.stabilitySeverity':
      allValues = allValues.concat(data);
      break;
    case 'category':
    case 'patchDetail.category':
      let processedCategories = getPatchCategorySeverityOptions(
        data.getPatchAllCategorySeverityMeta,
        'categories'
      );

      allValues = allValues.concat(processedCategories);
      break;
    case 'severity':
    case 'patchDetail.severity':
      let processedSeverities = getPatchCategorySeverityOptions(
        data.getPatchAllCategorySeverityMeta,
        'severities'
      );
      allValues = allValues.concat(processedSeverities);
      break;
    default:
      allValues = [];
  }
  return allValues;
};

const getTableVariables = (col) => {
  switch (col.name) {
    case 'client.name':
      return { listInfo: {} };
    default:
      return null;
  }
};

export {
  getDefaultValue,
  getDynamicQuery,
  checkDynamicQuery,
  generateOptions,
  getTableVariables,
  setAPIResolverModule,
  getPatchCategorySeverityOptions,
  getAsyncOptions
};
